import request from '@/utils/request'

export function getDashboardSummary() {
  return request({
    url: '/api/dashboard/summary',
    method: 'get'
  })
}

export function getDashboardWorkbench() {
  return request({
    url: '/api/dashboard/workbench',
    method: 'get'
  })
}

export function getSalesPersonDetail(params) {
  return request({
    url: '/api/dashboard/sales-person-detail',
    method: 'get',
    params
  })
}
